// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Z_nk","signatureBlock":"Footer_signatureBlock__1TuiU","signature":"Footer_signature__1-b6z"};